import React, { useState, useEffect } from "react";
import "./style.scss";
//nav bar
import Navbar from "../../../components/navbar/navbar";
import PageHeader from "../../../components/pageComponents/header";
import ThreeColText from "../../../components/pageComponents/threeColText";
// utile
import { debounce } from "../../../utils/debounce";
import { useTranslation } from "react-i18next";

const IntoxPage = () => {
  const { t } = useTranslation();
  const [isMobile, setMobile] = useState(
    window.innerWidth <= 600 || window.innerHeight <= 650
  );

  const debouncedHandleResize = debounce(function handleResize() {
    setMobile(window.innerWidth <= 600 || window.innerHeight <= 650);
  }, 300);

  useEffect(() => {
    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  });

  return (
    <div className="App">
      {!isMobile && <Navbar />}
      <div className={isMobile ? "page__mobile" : "page"}>
        <div className="App-header">
          <PageHeader
            title1={t("info_intox_title1")}
            title2={t("info_intox_title2")}
            subtitle={t("info_intox_subtitle")}
            color="#669933"
            bgImg={require("../../../images/pages/InfoIntox.jpg")}
            isMobile={isMobile}
          >
            <div className="page__content">{t("info_intox_text_intro_1")}</div>
            <div className="page__content">{t("info_intox_text_intro_2")}</div>
            <div className="page__content">{t("info_intox_text_intro_3")}</div>
          </PageHeader>
        </div>
        <ThreeColText
          col1Txt={[t("info_intox_text_core_1a"), t("info_intox_text_core_1b"), t("info_intox_text_core_1c")]}
          col2Txt={[t("info_intox_text_core_2a"),t("info_intox_text_core_2b")]}
          col3Txt={[t("info_intox_text_core_3a"),t("info_intox_text_core_3b"), t("info_intox_text_core_3c")]}
          col1Title={[
            t("mythe_text_title_1a"),
            t("mythe_text_title_1b"),
            t("mythe_text_title_1c"),
          ]}
          col2Title={[
            t("mythe_text_title_2a"),
            t("mythe_text_title_2b"),
            t("mythe_text_title_2c"),
          ]}
          col3Title={[
            t("mythe_text_title_3a"),
            t("mythe_text_title_3b"),
            t("mythe_text_title_3c"),
          ]}
          color="#669933"
        />
      </div>
    </div>
  );
};

export default IntoxPage;
